<template>
<div class="flex flex-col z-[99] relative" tabindex="0" @blur="close">
    <div class="flex flex-row justify-between h-10 p-2" :class="disabled?'cursor-not-allowed':'cursor-pointer'" @click="toggleOpen">
        <div class="flex" :class="selected?'text-white':'text-grey'">
            <span v-if="selected" class="w-4 h-4 mr-2 rounded self-center inline-block" :style="selected?`background-color:${getColor(selected)};`:''"></span>
            <span class="inline-block truncate">{{selected?getName(selected):placeholder}}</span>
        </div>
        <div class="mt-2">
            <svg v-if="open" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.83008 0.624219L0.830078 6.62422L1.90508 7.69922L6.83008 2.74922L11.7551 7.67422L12.8301 6.59922L6.83008 0.624219Z" fill="white"/>
            </svg>
            <svg v-else width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.83325 7.37578L0.833252 1.37578L1.90825 0.300781L6.83325 5.25078L11.7583 0.325781L12.8333 1.40078L6.83325 7.37578Z" fill="white"/>
            </svg>
        </div>
    </div>
    <div v-if="open" class="flex flex-col z-[999] absolute max-h-96 overflow-auto w-[calc(100%_-_10px)]" :class="classValue?classValue:'top-[90px]'">
        <div @click="select('')" class="relative flex flex-row gap-[8px] border-t border-light-black drop-shadow transition duration-500 bg-theme-modalbg hover:bg-theme-grey cursor-pointer" :key="'default'" value="">
            <div class="self-center"><span class="w-8 h-8 rounded inline-block"></span></div>
            <div class="inline-block self-center">{{placeholder}}</div>
        </div>
        <div @click="select(option.id)" :class="option.id==selected?'bg-[#425755] border-l-[4px] border-theme-green':'pl-[4px] border-t border-light-black bg-theme-modalbg'" class="relative flex flex-row gap-[8px] p-2 drop-shadow transition duration-500 hover:bg-theme-grey cursor-pointer" v-for="option in options" :key="'brd-'+option.id" :value="option.id">
            <div>
                <svg v-if="option.id==selected" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10Z" fill="#2BA66B"/>
                </svg>

                <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM2 10C2 14.42 5.58 18 10 18C14.42 18 18 14.42 18 10C18 5.58 14.42 2 10 2C5.58 2 2 5.58 2 10Z" fill="white"/>
                </svg>
            </div>
            <div class="inline-block break-all">{{option.name}}{{ option.businessBrandProfile?.name ? ' [' + option.businessBrandProfile?.name + ']' : '' }}</div>
        </div>
    </div>
</div>
</template>
<script>
import {defineComponent} from 'vue'
export default defineComponent({
    props: {
        modelValue: String,
        placeholder:String,
        options: Array,
        disabled: Boolean,
        classValue: String
    },
    data(){
        return {
            open: false,
            selected: ''
        }
    },
    mounted(){
        this.selected = this.modelValue
    },
    watch: {
        modelValue(){
            this.selected = this.modelValue
        }
    },
    methods: {
        toggleOpen(){
            if(!this.disabled){
                this.open = !this.open
            }
        },
        close(){
            this.open = false
        },
        isAdded(id){
            return this.selected.includes(id)
        },
        getName(id){
            if(!id) return
            
            if(id=='noCategory'){
                return 'No Category'
            }else{
                let obj = this.options.find(each => each.id==id)
                if(obj) return obj.name
            }
        },
        getColor(id){
            let obj = this.options.find(each => each.id==id)
            if(obj) return obj.posColour
        },
        select(id){
            this.selected = id
            this.$emit('update:modelValue', this.selected)
            this.$emit('changed', this.selected)
            this.close()
        }
    }
})
</script>